import { Checkbox, Form } from 'antd';
import React from 'react';
import styles from './EnableAlisaField.module.scss';
import { fieldNames } from '../../../common/config';

const enableAlisaFieldName = fieldNames.enableAlisa;
const FormItem = Form.Item;

const EnableAlisaField = ({ form }) => {
  const handleChange = (e) => {
    if (e.target.checked === false) {
      form.resetFields([fieldNames.alisaText]);
      form.resetFields([fieldNames.alisaTemplate]);
    }
  };

  return (
    <FormItem style={{ margin: 0 }}>
      {form.getFieldDecorator(enableAlisaFieldName, {
        valuePropName: 'checked',
      })(
        <Checkbox
          onChange={handleChange}
          className={styles.custonCheckbox}
        >
          Включить автоответчик
        </Checkbox>
      )}
    </FormItem>
  );
};

export default EnableAlisaField;
